import { http } from '@packet/management/src/api/http';
import type {
  CreatePermissionRequest,
  UpdatePermissionRequest,
  GetPermissionListRequest,
  GetPermissionListResponse,
  GetPermissionDetailRequest,
  GetPermissionDetailResponse,
  DeletePermissionRequest,
} from '../../DTO/permission';
import type { ApiResponse } from '../../DTO/common';

/**
 * 获取权限列表
 */
export const getPermissionList = async (params: GetPermissionListRequest): Promise<ApiResponse<GetPermissionListResponse>> => {
  return http().get('/api/v1/permissions/list', params);
};

/**
 * 创建权限
 */
export const createPermission = async (data: CreatePermissionRequest): Promise<ApiResponse<null>> => {
  return http().post('/api/v1/permissions/create', data);
};

/**
 * 更新权限
 */
export const updatePermission = async (data: UpdatePermissionRequest): Promise<ApiResponse<null>> => {
  return http().put('/api/v1/permissions/update', data);
};

/**
 * 删除权限
 */
export const deletePermission = async (params: DeletePermissionRequest): Promise<ApiResponse<null>> => {
  return http().del(`/api/v1/permissions/delete?id=${params.id}`);
};

/**
 * 获取权限详情
 */
export const getPermissionDetail = async (params: GetPermissionDetailRequest): Promise<ApiResponse<GetPermissionDetailResponse>> => {
  return http().get('/api/v1/permissions/get', params);
};
